import { InlineIcon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import './Bigger.style.scss';
// import { useAppDispatch } from '@/store';
import Dialog from '@mui/material/Dialog';

type TBiggerProps = {
    title?: string,
    numberGraph? : number
}
const Bigger: React.FC<{ children: React.ReactNode } & {objBiggerProps: TBiggerProps }> = ({
    children,
    objBiggerProps
}) => {

    const [isBigger, setisBigger] = useState(false);
    const [displayTitle, setDisplayTitle] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setDisplayTitle(true);
        }, 5000);
    }, [displayTitle]);

    // const dispatch = useAppDispatch();

    const updateBigger = () => {
        setisBigger(!isBigger);
    }

    return (
        <div className={classNames('bigger-container')} >
            <div className="bigger-content">
                <div className='bigger-header'>
                    <span> 
                         {objBiggerProps?.title}
                    </span>
                    <InlineIcon className='icon' icon={!isBigger ? 'bx:expand' : 'fe:compress'} onClick={(e) => { updateBigger() }
                    } />
                </div>

                <div className='bigger-body'>
                    {children}
                </div>
            </div>

            <>
            {
                isBigger && (
                    <Dialog
                    sx={{ width: "100%", height: "100%" }}
                    open={isBigger}
                    onClose={updateBigger}
                    fullScreen
                    aria-labelledby="responsive-dialog-title"
                >
                     <div className='bigger-body-fullscreen fullscreen-bigger'>
                        <div className='header-fullscreem-bigger'>
    
                            <div className='btn-part'>
                                <span> 
                                    {objBiggerProps?.title}
                                </span>
                                <InlineIcon className='icon' icon={!isBigger ? 'bx:expand' : 'fe:compress'} onClick={(e) => { updateBigger() }
                                } />
                            </div>
    
                        </div>
                        {children}
                     </div>
                </Dialog>
                )
            }
            </>
           

        </div>
    )
}

export default Bigger